export default class FormAction {
	_id;
	_formId;
	_parentFieldId;
	_gridFormParent;
	_confirmsWith;
	_disableWith;
	_disabled;
	_hidden;
	_icon;
	_label;
	_method;
	_name;
	_presentationType;
	_style;
	_type;

	constructor(actionProps = {}) {
		Object.keys(actionProps)
		.forEach((propName) => this[propName] = actionProps[propName]);
	}

	get id() {
		return this._id;
	}

	set id(value) {
		this._id = value;
	}

	get formId() {
		return this._formId;
	}

	set formId(value) {
		this._formId = value;
	}

	get parentFieldId() {
		return this._parentFieldId;
	}

	set parentFieldId(value) {
		this._parentFieldId = value;
	}

	get gridFormParent() {
		return this._gridFormParent;
	}

	set gridFormParent(value) {
		this._gridFormParent = value;
	}

	get confirmsWith() {
		return this._confirmsWith;
	}

	set confirmsWith(value) {
		this._confirmsWith = value;
	}

	get disableWith() {
		return this._disableWith;
	}

	set disableWith(value) {
		this._disableWith = value;
	}

	get disabled() {
		return this._disabled;
	}

	set disabled(value) {
		this._disabled = value;
	}

	get hidden() {
		return this._hidden;
	}

	set hidden(value) {
		this._hidden = value;
	}

	get icon() {
		return this._icon;
	}

	set icon(value) {
		this._icon = value;
	}

	get label() {
		return this._label;
	}

	set label(value) {
		this._label = value;
	}

	get method() {
		return this._method;
	}

	set method(value) {
		this._method = value;
	}

	get name() {
		return this._name;
	}

	set name(value) {
		this._name = value;
	}

	get presentationType() {
		return this._presentationType;
	}

	set presentationType(value) {
		this._presentationType = value;
	}

	get style() {
		return this._style;
	}

	set style(value) {
		this._style = value;
	}

	get type() {
		return this._type;
	}

	set type(value) {
		this._type = value;
	}
}
